/**
 * Arial Unicode MS
 * Font Weight: 400
 */
export default {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontStyle: 'normal',
    unitsPerEm: 2048,
    metrics: {
        ascender: 2189,
        descender: -555,
        lineGap: 0,
    },
    glyphs: {
        '"': 727,
        '%': 1821,
        '\'': 391,
        '*': 797,
        '@': 2079,
        'M': 1706,
        'W': 1933,
        '^': 961,
        'm': 1706,
        '{': 684,
        '|': 532,
        '}': 684,
        '¦': 532,
        '©': 1509,
        'ª': 758,
        '®': 1509,
        '°': 819,
        '¶': 1100,
        'º': 748,
        'æ': 1821,
        'ď': 1284,
        'Ĳ': 1538,
        'ĳ': 909,
        'ĸ': 895,
        'ŀ': 651,
        'ŉ': 1282,
        'Ŋ': 1481,
        'œ': 1933,
        'ť': 831,
        'Ŵ': 1933,
        'Ɓ': 1516,
        'Ƃ': 1341,
        'Ƈ': 1569,
        'ƈ': 1186,
        'Ɗ': 1616,
        'Ƌ': 1341,
        'ƍ': 1141,
        'Ə': 1493,
        'Ɛ': 1237,
        'Ɠ': 1620,
        'Ɣ': 1329,
        'ƕ': 1651,
        'Ɩ': 502,
        'Ɨ': 659,
        'ƚ': 659,
        'Ɯ': 1706,
        'Ơ': 1589,
        'Ƣ': 2087,
        'ƣ': 1602,
        'Ƥ': 1505,
        'Ʃ': 1233,
        'ƪ': 750,
        'Ƭ': 1169,
        'Ư': 1589,
        'ư': 1270,
        'Ʊ': 1532,
        'Ƴ': 1540,
        'ƴ': 1260,
        'Ʒ': 1286,
        'Ƹ': 1286,
        'ƹ': 1077,
        'ƺ': 983,
        'ƽ': 1077,
        'ǁ': 950,
        'ǂ': 971,
        'Ǆ': 2730,
        'ǅ': 2503,
        'ǆ': 2163,
        'Ǉ': 2109,
        'ǉ': 909,
        'Ǌ': 2503,
        'ǋ': 1933,
        'ǣ': 1821,
        'Ǯ': 1094,
        'ǯ': 1094,
        'Ǳ': 2730,
        'ǲ': 2503,
        'ǳ': 2163,
        'ǽ': 1821,
        'ʹ': 631,
        '͵': 631,
        'Έ': 1442,
        'Ή': 1554,
        'Ί': 645,
        'Ύ': 1528,
        'Ώ': 1552,
        'Γ': 1126,
        'Δ': 1397,
        'Μ': 1706,
        'Ξ': 1331,
        'Σ': 1233,
        'Φ': 1655,
        'Ψ': 1647,
        'Ω': 1552,
        'ά': 1180,
        'έ': 889,
        'ΰ': 1128,
        'α': 1180,
        'β': 1153,
        'δ': 1141,
        'ε': 889,
        'ζ': 901,
        'κ': 1020,
        'μ': 1133,
        'ξ': 885,
        'ρ': 1169,
        'ς': 967,
        'σ': 1268,
        'τ': 782,
        'υ': 1128,
        'φ': 1329,
        'χ': 1069,
        'ψ': 1493,
        'ω': 1569,
        'ϋ': 1128,
        'ύ': 1128,
        'ώ': 1569,
        'ϐ': 1153,
        'ϑ': 1262,
        'ϒ': 1292,
        'ϓ': 1487,
        'ϔ': 1292,
        'ϕ': 1319,
        'ϖ': 1599,
        'Ϝ': 1184,
        'Ϟ': 1167,
        'Ϡ': 1417,
        'Ϣ': 1802,
        'ϣ': 1706,
        'Ϥ': 1401,
        'ϥ': 1143,
        'Ϧ': 1393,
        'ϧ': 1083,
        'Ϩ': 1141,
        'ϩ': 1034,
        'Ϫ': 1276,
        'ϫ': 1235,
        'Ϭ': 1249,
        'Ϯ': 1163,
        'ϯ': 889,
        'ϱ': 1169,
        ' ': 512,
        ' ': 342,
        ' ': 205,
        ' ': 102,
        '​': 0,
        '‌': 0,
        '‍': 0,
        '―': 1155,
        '‖': 877,
        '•': 717,
        '‣': 717,
        '\u2028': 0,
        '\u2029': 0,
        '‱': 2724,
        '″': 762,
        '‴': 1069,
        '‵': 422,
        '‶': 729,
        '‷': 1036,
        '‸': 639,
        '‼': 965,
        '‿': 1935,
        '⁀': 1935,
        '⁁': 639,
        '⁂': 1679,
        '⁄': 342,
        '⁽': 430,
        '⁾': 430,
        '₍': 430,
        '₎': 430,
        '₥': 1706,
        '₨': 2097,
        '₩': 1925,
        '₪': 1606,
        '℀': 1821,
        '℁': 1821,
        '℃': 2093,
        '℅': 1821,
        '℆': 1821,
        'ℇ': 1026,
        '℉': 1886,
        'ℊ': 1044,
        'ℋ': 1855,
        'ℌ': 2023,
        'ℐ': 1409,
        'ℑ': 1133,
        'ℒ': 1450,
        'ℓ': 596,
        '№': 2198,
        '℗': 1509,
        '℘': 1516,
        'ℛ': 1898,
        'ℜ': 1628,
        '℡': 2404,
        '℥': 1110,
        'Ω': 1573,
        '℧': 1573,
        'ℨ': 1430,
        '℩': 657,
        'ℬ': 1898,
        'ℭ': 1323,
        'ℯ': 788,
        'ℰ': 1260,
        'ℱ': 1409,
        'ℳ': 2284,
        'ℴ': 831,
        'ℵ': 1409,
        'ℶ': 1409,
        'ℷ': 705,
        'ℸ': 1409,
        'Ⅱ': 1137,
        'Ⅲ': 1704,
        'Ⅳ': 1911,
        'Ⅵ': 1913,
        'Ⅶ': 2111,
        'Ⅷ': 2597,
        'Ⅸ': 1933,
        'Ⅺ': 1933,
        'Ⅻ': 2120,
        'Ⅿ': 1706,
        'ⅱ': 909,
        'ⅲ': 1364,
        'ⅳ': 1434,
        'ⅵ': 1434,
        'ⅶ': 1888,
        'ⅷ': 2343,
        'ⅸ': 1458,
        'ⅺ': 1458,
        'ⅻ': 1913,
        'ⅿ': 1706,
        'ↀ': 2013,
        'ↂ': 2013,
        '↭': 1665,
        '↮': 1665,
        '⇎': 1946,
        '⇔': 1767,
        '⇜': 1665,
        '⇝': 1665,
        '∂': 1012,
        '∆': 1253,
        '∇': 1253,
        '∏': 1686,
        '∐': 1686,
        '∕': 342,
        '∗': 797,
        '∘': 819,
        '∙': 819,
        '∣': 532,
        '∤': 909,
        '∥': 856,
        '∦': 1233,
        '∫': 1036,
        '∬': 1651,
        '∭': 2265,
        '∮': 1036,
        '∯': 1651,
        '∰': 2265,
        '∱': 1036,
        '∲': 1036,
        '∳': 1036,
        '∶': 864,
        '≀': 864,
        '≔': 1509,
        '≕': 1509,
        '≪': 1985,
        '≫': 1985,
        '⊑': 1378,
        '⊒': 1378,
        '⊦': 817,
        '⊧': 817,
        '⊫': 1376,
        '⊯': 1376,
        '⋅': 512,
        '⋇': 1329,
        '⋈': 1290,
        '⋉': 1290,
        '⋊': 1290,
        '⋋': 1290,
        '⋌': 1290,
        '⋐': 1368,
        '⋑': 1368,
        '⋒': 1368,
        '⋓': 1368,
        '⋕': 1233,
        '⋘': 2773,
        '⋙': 2773,
        '⋢': 1378,
        '⋣': 1378,
        '⋤': 1378,
        '⋥': 1378,
        '⌈': 920,
        '⌉': 920,
        '⌊': 920,
        '⌋': 920,
        '⌗': 1331,
        '⌘': 1597,
        '⌠': 1036,
        '⌡': 1036,
        '〈': 674,
        '〉': 674,
        '★': 1671,
        '☆': 1686,
        '☎': 1473,
        '☏': 1473,
        '☐': 1503,
        '☑': 1503,
        '☒': 1503,
        '☓': 1561,
        '☚': 1966,
        '☛': 1966,
        '☜': 1923,
        '☝': 1923,
        '☞': 1923,
        '☟': 1923,
        '☤': 1188,
        '☥': 942,
        '☦': 909,
        '☧': 1331,
        '☨': 909,
        '☩': 1573,
        '☫': 1741,
        '☬': 1382,
        '☰': 1843,
        '☱': 1843,
        '☲': 1843,
        '☳': 1843,
        '☴': 1843,
        '☵': 1843,
        '☶': 1843,
        '☷': 1843,
        '☿': 1516,
        '♀': 1516,
        '♁': 1516,
        '♂': 1516,
        '♃': 1337,
        '♄': 1004,
        '♅': 1294,
        '♆': 1597,
        '♇': 1147,
        '♈': 1716,
        '♉': 1597,
        '♊': 1503,
        '♋': 1817,
        '♌': 1597,
        '♍': 2212,
        '♎': 1835,
        '♏': 2212,
        '♐': 1647,
        '♑': 1778,
        '♒': 1888,
        '♓': 1425,
        '♡': 1503,
        '♢': 1380,
        '♣': 1647,
        '♥': 1503,
        '♦': 1380,
        '♧': 1647,
        '♨': 1761,
        '♩': 866,
        '♪': 1212,
        '♭': 899,
        '♮': 899,
        '♯': 899,
        '✁': 1995,
        '✂': 1968,
        '✃': 1995,
        '✄': 2007,
        '✆': 1616,
        '✇': 1618,
        '✈': 1620,
        '✉': 1413,
        '✍': 1751,
        '✎': 1866,
        '✏': 1911,
        '✐': 1866,
        '✑': 1935,
        '✒': 1995,
        '✓': 1546,
        '✔': 1733,
        '✕': 1561,
        '✖': 1559,
        '✗': 1169,
        '✘': 1386,
        '✙': 1563,
        '✚': 1556,
        '✛': 1554,
        '✜': 1544,
        '✝': 1012,
        '✞': 1130,
        '✟': 1100,
        '✠': 1182,
        '✡': 1417,
        '✢': 1610,
        '✥': 1618,
        '✦': 1624,
        '✧': 1626,
        '✩': 1686,
        '✪': 1616,
        '✫': 1722,
        '✬': 1686,
        '✭': 1706,
        '✮': 1671,
        '✯': 1702,
        '✰': 1890,
        '✱': 1524,
        '✲': 1481,
        '✳': 1534,
        '✴': 1618,
        '✵': 1622,
        '✶': 1423,
        '✷': 1589,
        '✸': 1573,
        '✹': 1622,
        '✺': 1554,
        '✻': 1448,
        '✼': 1450,
        '✽': 1397,
        '✾': 1436,
        '✿': 1692,
        '❀': 1669,
        '❁': 1616,
        '❂': 1616,
        '❃': 1448,
        '❄': 1407,
        '❅': 1425,
        '❆': 1411,
        '❇': 1610,
        '❈': 1612,
        '❊': 1620,
        '❋': 1608,
        '❍': 1788,
        '❏': 1561,
        '❐': 1561,
        '❑': 1554,
        '❒': 1554,
        '❖': 1606,
        '❘': 283,
        '❙': 567,
        '❚': 850,
        '❛': 803,
        '❜': 803,
        '❝': 1368,
        '❞': 1368,
        '❡': 1499,
        '❢': 1114,
        '❣': 1114,
        '❤': 1864,
        '❦': 1556,
        '❧': 1556,
        '➔': 1831,
        '➘': 1532,
        '➙': 1892,
        '➚': 1532,
        '➛': 1880,
        '➜': 1898,
        '➝': 1901,
        '➞': 1901,
        '➠': 1788,
        '➡': 1696,
        '➢': 1892,
        '➣': 1892,
        '➤': 1878,
        '➥': 1905,
        '➦': 1907,
        '➧': 948,
        '➨': 1808,
        '➩': 1712,
        '➪': 1712,
        '➫': 1776,
        '➬': 1776,
        '➭': 1425,
        '➮': 1425,
        '➯': 1790,
        '➱': 1790,
        '➲': 1556,
        '➳': 1937,
        '➴': 1579,
        '➵': 1772,
        '➶': 1579,
        '➷': 1819,
        '➸': 1980,
        '➹': 1819,
        '➺': 1702,
        '➻': 1788,
        '➼': 1898,
        '➽': 1987,
        '➾': 1880,
        '匭': 2036,
        '憁': 2050,
        '鐧': 2044,
    },
    glyphsByWidth: {
        455: 'ijlĩīĭįĵĺļľłſǰΐίιϊϳ‘’‚‛′ⅰⅼ',
        569: ' \t\n\r!,./:;I[\\]ft ·ÌÍÎÏìíîïĨĪĬĮİıţŧƒƫƭǀǃǏǐȈȉȊȋͺ;΄΅·ΙΪ ․‧⁅⁆Ⅰ∖⋮',
        682: '()-`r¡¨­²³´¸¹ŕŗřȑȓ ‐‑“”„‟‹›⁃⁰⁴⁵⁶⁷⁸⁹⁺⁻⁼ⁿ₀₁₂₃₄₅₆₇₈₉₊₋₌',
        1024: 'J_cksvxyz¯çýÿćĉċčĴķśŝşšŷźżžƙƛƨƶǩγλνϲ  –‗‾ℎℏⅴⅹⅽ☇☈｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟﾠﾡﾢﾣﾤﾥﾦﾧﾨﾩﾪﾫﾬﾭﾮﾯﾰﾱﾲﾳﾴﾵﾶﾷﾸﾹﾺﾻﾼﾽﾾￂￃￄￅￆￇￊￋￌￍￎￏￒￓￔￕￖￗￚￛￜ￨￩￪￫￬￭￮',
        1124: '∈∉∊∋∌∍∎∝∞⊢⊣⊤⊥⊨⊩⊪⊬⊭⊮⊰⊱⊲⊳⊴⊵⊹⊺⋄⋆⌀⌂⌃⌄⌅⌆⌇⌌⌍⌎⌏⌐⌑⌔⌕⌖⌙⌚⌛⌜⌝⌞⌟⌬⌭⌮⌯⌰⌱⌲⌳⌴⌵✌',
        1139: '#$0123456789?Labdeghnopqu¢£¤¥§«µ»àáâãäåèéêëðñòóôõöùúûüþāăąđēĕėęěĝğġģĥħĹĻĽĿŁńņňŋōŏőũūŭůűųƀƃƄƅƌƞơƥƻƼƾƿǎǒǔǖǘǚǜǝǟǡǥǧǫǭǵǻȁȃȅȇȍȏȕȗήηθοό ‒†‡‥‽₠₡₢₣₤₦₧₫€ℙ℮Ⅼⅾ',
        1149: '∧∨∩∪∴∵∷⊌⊍⊎⊓⊔⋀⋁⋂⋃⋎⋏⋔',
        1196: '+<=>~¬±×÷−∓∔∟∠∡∢∸∹∺∻∼∽∾∿≁≂≃≄≅≆≇≈≉≊≋≌≍≎≏≐≑≒≓≖≗≘≙≚≛≜≝≞≟≠≡≢≣≤≥≦≧≨≩≬≭≮≯≰≱≲≳≴≵≶≷≸≹≺≻≼≽≾≿⊀⊁⊻⊼⊽⊾⊿⋍⋖⋗⋚⋛⋜⋝⋞⋟⋠⋡⋦⋧⋨⋩⋪⋫⋬⋭',
        1229: 'ϰ∀∁∃∄√∛∜⌶⌷⌸⌹⌺⌻⌼⌽⌾⌿⍀⍁⍂⍃⍄⍅⍆⍇⍈⍉⍊⍋⍌⍍⍎⍏⍐⍑⍒⍓⍔⍕⍖⍗⍘⍙⍚⍛⍜⍝⍞⍟⍠⍡⍢⍣⍤⍥⍦⍧⍨⍩⍪⍫⍬⍭⍮⍯⍰⍱⍲⍳⍴⍵⍶⍷⍸⍹⍺⎕─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋╌╍╎╏═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳╴╵╶╷╸╹╺╻╼╽╾╿▀▁▂▃▄▅▆▇█▉▊▋▌▍▎▏▐░▒▓▔▕■□▢▣▤▥▦▧▨▩▪▫▬▭▮▯▰▱▲△▴▵▶▷▸▹►▻▼▽▾▿◀◁◂◃◄◅◆◇◈◉◊○◌◍◎●◐◑◒◓◔◕◖◗◘◙◚◛◜◝◞◟◠◡◢◣◤◥◦◧◨◩◪◫◬◭◮◯☡',
        1251: 'FTZ¿ßøŢŤŦŹŻŽƑƮƵǿΖΤϭ℄ℤℲ',
        1366: '&ABEKPSVXYÀÁÂÃÄÅÈÉÊËÝÞĀĂĄĒĔĖĘĚĶŚŜŞŠŶŸƎƘƧƲǍǞǠǨǺȀȂȄȆΆΑΒΕΚΛΡΥΧΫℂ℈ℝ℞℟KÅⅤⅩ❥',
        1389: 'π⊂⊃⊄⊅⊆⊇⊈⊉⊊⊋⊏⊐',
        1460: '←↑→↓↔↕↖↗↘↙↚↛↜↝↞↟↠↡↢↣↤↥↦↧↨↩↪↫↬↯↰↱↲↳↴↵↶↷↸↹↼↽↾↿⇀⇁⇂⇃⇄⇅⇆⇇⇈⇉⇊⇋⇌⇍⇏⇐⇑⇒⇓⇕⇖⇗⇘⇙⇚⇛⇞⇟⇠⇡⇢⇣⇤⇥⇦⇧⇨⇩⇪∑⊶⊷⊸⌢⌣❉',
        1479: 'CDHNRUwÇÐÑÙÚÛÜĆĈĊČĎĐĤĦŃŅŇŔŖŘŨŪŬŮŰŲŵƆƉƝƦǓǕǗǙǛȐȒȔȖΗΝΠϚℍℕℚ℣ⅭⅮↁ♠♤',
        1536: '☀☂☃☠☢☣☮☯☸☹☺☻☼☽☾♫♬',
        1593: 'GOQÒÓÔÕÖØĜĞĠĢŌŎŐƟǈǌǑǤǦǪǬǴǾȌȎΌΘΟ℔',
        1614: '✣✤❶❷❸❹❺❻❼❽❾❿➀➁➂➃➄➅➆➇➈➉➊➋➌➍➎➏➐➑➒➓',
        1638: '↺↻∅⊕⊖⊗⊘⊙⊚⊛⊜⊝⊞⊟⊠⊡⌒⌓☉☊☋☌☍☪☭',
        1708: '¼½¾⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞⅟➟',
    },
    defaultWidth: 2048,
};
